import {Component, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppStateService } from './core/services/app-state.service';
import {VoiceJobService} from "@/core/services/external/voice-job.service";
import {filter, forkJoin, take} from "rxjs";
import {SsoService} from "@/core/services/external/sso.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  title = 'FusionLex';

  constructor(
      private appState : AppStateService,
      private ssoService: SsoService
  ){
    this.appState.updateState();
  }

  ngOnInit() {
    this.ssoService.currentUser
        .pipe(
            filter(user => !!user),
            take(1)
        )
        .subscribe(() => {
          this.appState.refreshJobs();
        });
    // TODO: IN UPLOAD PAGE this.appState.refreshJobs();
  }
}
